var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 62,
    viewBox: "0 0 38 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7742 26.696C29.7706 26.696 27.7555 23.612 28.9617 20.8613L35.4887 5.97668C36.7244 3.15908 34.6603 0 31.5835 0H16.6619C14.9691 0 13.4364 1.00136 12.7566 2.55173L0.28405 30.9951C-0.680962 33.196 0.931161 35.6634 3.33433 35.6634H14.1882C16.3981 35.6634 17.9953 37.776 17.3926 39.9021L11.8729 59.3789C11.2593 61.5442 14.077 62.974 15.4623 61.2002L36.4784 34.2883C38.888 31.2027 36.6895 26.696 32.7742 26.696Z",
    fill: "url(#paint0_linear_37093_11212)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37093_11212",
    x1: 16.6962,
    y1: -16.2024,
    x2: 20.2974,
    y2: 68.4278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreak);
export default __webpack_public_path__ + "static/media/streak.1d2a2f410d2c9acb74de554e83bf9e52.svg";
export { ForwardRef as ReactComponent };